import { z } from 'zod';
import { CardType } from '@scale/genai-compass-shared/cardTypes';
import { CardVariant } from '@scale/compass-shared/types';
import type { CompassCardUI } from '@scale/compass-ui/types';
import NoopActionComponent from '@scale/compass-ui/components/NoopActionComponent';

export const blankCardUI: CompassCardUI<any> = {
  variant: CardVariant.ACTION,
  title: 'Noop Action',
  icon: 'question',
  toolTip: 'Noop Action',
  defaultContext: {
    cardType: CardType.NOOP_ACTION,
  },
  cardType: CardType.NOOP_ACTION,
  schema: z.any(),
  legacyComponent: NoopActionComponent,
};
